var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-PDC"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDC",
    clipPath: "url(#clip-PDC)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    transform: "translate(12.501 117.099)",
    fill: "#090000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,44.608l483.843-.485L455.772,1.234,18.142,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 453.8951721191406 2.46236252784729 L 479.9246215820312 42.62965393066406 L 3.831418037414551 43.04310989379883 L 20.52019882202148 1.287499666213989 L 453.8951721191406 2.46236252784729 M 455.7724304199219 1.23448371887207 L 18.14225578308105 2.167939601349644e-05 L 0.0001313125976594165 44.60763931274414 L 483.8428344726562 44.12278747558594 L 455.7724304199219 1.23448371887207 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "D-Link",
    transform: "translate(176.371 125.202)",
    fill: "#f9f8f8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.061,22.916,5.446,8.179l9.429.02q3.542.008,6.283.451t4.692,1.324q1.951.881,3.121,2.2t1.563,3.091q.765,3.44-2.7,5.52-3.5,2.1-10.087,2.112ZM11.945,10.83l1.762,9.326,3.032,0q3.972,0,5.958-1.315T24.2,15.306q-.439-2.087-2.892-3.279t-6.423-1.193Zm33.525,7.5-10.193.005-.522-2.269H44.906Zm22.664,4.485-15.887.027L48.463,8.271l5.867.013,3.2,11.829,9.815-.01Zm2.34-12.048q-1.446,0-2.508-.475T66.7,9.138q-.206-.7.582-1.14t2.224-.436q1.455,0,2.5.447T73.263,9.15q.218.71-.553,1.164T70.474,10.766ZM76.968,22.8l-5.836.01L68.056,12.376l5.727.006Zm23-.039-5.746.01-1.964-5.812q-.4-1.2-1.372-1.8t-2.5-.6q-1.479,0-2.229.631t-.433,1.613l1.945,5.974-5.8.01-3.276-10.4,5.7.006.526,1.617h.072q1.424-1.863,5.3-1.858,3.051,0,4.935,1.056t2.621,3.165Zm23.1-.039-6.831.012-7.816-5.163h-.072l1.9,5.173-5.733.01L99.1,7.582l5.579.013,3.508,9.541h.072l3.68-4.714,6.638.007-4.682,4.786Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 124.1228256225586 22.99569511413574 L 123.1732940673828 22.99736976623535 L 116.3391265869141 23.00943756103516 L 116.0735092163086 23.00990295410156 L 115.881721496582 22.88315200805664 L 109.1477890014648 18.43279266357422 L 110.7361068725586 22.74198341369629 L 110.8382568359375 23.01914978027344 L 110.3499450683594 23.02001190185547 L 104.6141967773438 23.03013801574707 L 104.1242523193359 23.03100204467773 L 104.0253829956055 22.75333404541016 L 98.62263488769531 7.581035614013672 L 98.52935791015625 7.319087982177734 L 99.00569152832031 7.320244789123535 L 104.5824584960938 7.333791732788086 L 105.057258605957 7.334945678710938 L 105.1536483764648 7.596445083618164 L 108.3540115356445 16.27923583984375 L 111.4826583862305 12.27805519104004 L 111.5778045654297 12.15639495849609 L 111.838134765625 12.15669250488281 L 118.4727554321289 12.16427326202393 L 119.4342575073242 12.16537189483643 L 119.0180816650391 12.59138298034668 L 114.4960021972656 17.22027206420898 L 123.3943405151367 22.55865287780762 L 124.1228256225586 22.99569511413574 Z M 116.3948669433594 22.45578575134277 L 122.0079879760742 22.44670677185059 L 113.5636825561523 17.37516212463379 L 113.2920303344727 17.21199417114258 L 113.4488754272461 17.0518798828125 L 117.7174224853516 12.69462776184082 L 112.299934387207 12.689208984375 L 108.718879699707 17.28374481201172 L 108.6647491455078 17.35317802429199 L 108.7703704833984 17.42289543151855 L 116.3948669433594 22.45578575134277 Z M 104.905403137207 22.47436332702637 L 109.6582489013672 22.4666805267334 L 107.8623733520508 17.57021903991699 L 107.8030090332031 17.40835762023926 L 107.7034378051758 17.13687324523926 L 104.2994995117188 7.856029033660889 L 99.66945648193359 7.845427513122559 L 104.905403137207 22.47436332702637 Z M 100.554931640625 23.03730583190918 L 100.0639266967773 23.03817176818848 L 94.31481170654297 23.04832077026367 L 93.82217407226562 23.04919052124023 L 93.72836303710938 22.7707462310791 L 91.7698974609375 16.95794296264648 C 91.60900115966797 16.4804515838623 91.39176177978516 16.10911560058594 91.13912200927734 15.82060813903809 C 90.88673400878906 15.53238964080811 90.59888458251953 15.32663726806641 90.29649353027344 15.1803560256958 C 89.99423980712891 15.03413486480713 89.67734527587891 14.94726657867432 89.36675262451172 14.89691734313965 C 89.05618286132812 14.84657001495361 88.75186920166016 14.83272933959961 88.47489166259766 14.83261203765869 C 88.26407623291016 14.83252239227295 88.06737518310547 14.84339141845703 87.88423919677734 14.86537647247314 C 87.70106506347656 14.88736629486084 87.53144836425781 14.92047691345215 87.37480926513672 14.96487140655518 C 87.2181396484375 15.00928115844727 87.07447814941406 15.06498432159424 86.94322967529297 15.13214206695557 C 86.81194305419922 15.19932460784912 86.69308471679688 15.27797603607178 86.58612060546875 15.36826801300049 C 86.47495269775391 15.46211528778076 86.38388824462891 15.56187629699707 86.31285858154297 15.66797733306885 C 86.24179840087891 15.77412796020508 86.19076538085938 15.88662433624268 86.15968322753906 16.00589561462402 C 86.12858581542969 16.12522506713867 86.11745452880859 16.25134086608887 86.12619018554688 16.38467025756836 C 86.13492584228516 16.51806640625 86.16355895996094 16.65869140625 86.21197509765625 16.80697250366211 L 88.16260528564453 22.78016090393066 L 88.25366973876953 23.05902481079102 L 87.75943756103516 23.05989646911621 L 81.95406341552734 23.07014465332031 L 81.45816802978516 23.07102012634277 L 81.3704833984375 22.79164886474609 L 78.10408020019531 12.38643550872803 L 78.01982879638672 12.11805152893066 L 78.50606536865234 12.11860656738281 L 84.19860076904297 12.12511253356934 L 84.68324279785156 12.12566566467285 L 84.77073669433594 12.39357948303223 L 85.04379272460938 13.22973823547363 C 85.31735992431641 13.00503826141357 85.62847900390625 12.80836391448975 85.97669219970703 12.63980674743652 C 86.32459259033203 12.47139453887939 86.70958709716797 12.33102226257324 87.1312255859375 12.21880054473877 C 87.55256652832031 12.10665512084961 88.01056671142578 12.02259826660156 88.50479888916016 11.96675968170166 C 88.99880218505859 11.91094779968262 89.52906799316406 11.88331317901611 90.09523773193359 11.88399887084961 C 90.638916015625 11.88465690612793 91.15866851806641 11.9093542098999 91.65385437011719 11.95792293548584 C 92.14897918701172 12.00648784637451 92.61963653564453 12.07892894744873 93.06510925292969 12.17509651184082 C 93.51064300537109 12.27127456665039 93.93107604980469 12.39120292663574 94.32569885253906 12.53474235534668 C 94.72044372558594 12.67833042144775 95.08946228027344 12.84557914733887 95.43197631835938 13.0363597869873 C 95.76686859130859 13.2228889465332 96.07667541503906 13.4326810836792 96.36100769042969 13.66530895233154 C 96.64555358886719 13.89811325073242 96.90468597412109 14.15383911132812 97.137939453125 14.4320650100708 C 97.37143707275391 14.7105655670166 97.57908630371094 15.01166820526123 97.76045989990234 15.3349666595459 C 97.94205474853516 15.65864944458008 98.09735870361328 16.0046501159668 98.22592163085938 16.3725700378418 L 100.4578018188477 22.75936698913574 L 100.554931640625 23.03730583190918 Z M 94.61882019042969 22.49099922180176 L 99.37961578369141 22.48330307006836 L 97.25536346435547 16.37255668640137 C 97.13845062255859 16.03624725341797 96.99897003173828 15.7210111618042 96.83729553222656 15.42720603942871 C 96.67578125 15.13371562957764 96.49208068847656 14.86155223846436 96.28659057617188 14.61108684539795 C 96.08128356933594 14.36084175109863 95.85414886474609 14.1322078704834 95.60555267333984 13.92555713653564 C 95.35713958740234 13.7190523147583 95.08723449707031 13.53446388244629 94.79618072509766 13.37217998504639 C 94.50909423828125 13.21211528778076 94.20144653320312 13.0726261138916 93.87186431884766 12.95340251922607 C 93.54238128662109 12.83421516418457 93.19091796875 12.73525810241699 92.81613159179688 12.65623569488525 C 92.44137573242188 12.57722091674805 92.04322814941406 12.51812076568604 91.62028503417969 12.47864723205566 C 91.19732666015625 12.43917369842529 90.74952697753906 12.41932201385498 90.27546691894531 12.41881561279297 C 89.66939544677734 12.41816902160645 89.11428833007812 12.45291328430176 88.60861968994141 12.52357578277588 C 88.10268402099609 12.59427738189697 87.64614868164062 12.70095825195312 87.23751068115234 12.84417247772217 C 86.82855987548828 12.98750019073486 86.467529296875 13.16745948791504 86.15293121337891 13.38463115692139 C 85.83804321289062 13.60202884674072 85.56959533691406 13.85677242279053 85.34623718261719 14.14948272705078 L 85.24686431884766 14.27971172332764 L 84.97238922119141 14.27955436706543 L 84.90016937255859 14.27951431274414 L 84.41350555419922 14.27923679351807 L 84.32587432861328 14.00933361053467 L 83.88796234130859 12.66079330444336 L 79.16171264648438 12.65606689453125 L 82.27353668212891 22.51096343994141 L 87.08402252197266 22.5031852722168 L 85.23434448242188 16.80707168579102 C 85.17615509033203 16.62784576416016 85.14291381835938 16.45582008361816 85.13454437255859 16.29125213623047 C 85.12616729736328 16.12678718566895 85.14262390136719 15.96976280212402 85.18381500244141 15.82042980194092 C 85.22499084472656 15.67118740081787 85.29086303710938 15.52962112426758 85.38135528564453 15.39597988128662 C 85.47179412841797 15.26241493225098 85.58683013916016 15.13676643371582 85.72636413574219 15.01927757263184 C 85.86992645263672 14.89838600158691 86.03166198730469 14.79246520996094 86.21115112304688 14.70160102844238 C 86.39058685302734 14.61077690124512 86.58777618408203 14.53498554229736 86.80239105224609 14.47432231903076 C 87.01692199707031 14.41367816925049 87.24887847900391 14.36814117431641 87.49787139892578 14.33780860900879 C 87.74681091308594 14.30748271942139 88.01282501220703 14.29235172271729 88.29554748535156 14.29251194000244 C 88.70038604736328 14.2927417755127 89.1341552734375 14.32173824310303 89.56856536865234 14.39935684204102 C 90.00299835205078 14.47697925567627 90.438232421875 14.60326099395752 90.84608459472656 14.79814338684082 C 91.25416564941406 14.99313068389893 91.63505554199219 15.25690269470215 91.96060180664062 15.60960865020752 C 92.28655242919922 15.96274662017822 92.5572509765625 16.40530204772949 92.74440765380859 16.95780181884766 L 94.61882019042969 22.49099922180176 Z M 77.55039978027344 23.07792091369629 L 77.05333709716797 23.07879829406738 L 71.21483612060547 23.08910751342773 L 70.71610260009766 23.08998680114746 L 70.63375854492188 22.8098087310791 L 67.566650390625 12.37514686584473 L 67.48754119873047 12.10601806640625 L 67.97650146484375 12.10657691955566 L 73.70086669921875 12.11311721801758 L 74.188232421875 12.11367416381836 L 74.27060699462891 12.38232803344727 L 77.46463775634766 22.79825401306152 L 77.55039978027344 23.07792091369629 Z M 71.54781341552734 22.52831268310547 L 76.38571929931641 22.52048683166504 L 73.37728881835938 12.65028095245361 L 68.62458801269531 12.64552879333496 L 71.54781341552734 22.52831268310547 Z M 68.71402740478516 23.09352111816406 L 68.21464538574219 23.09440422058105 L 52.31970977783203 23.12246704101562 L 51.81598281860352 23.12335777282715 L 51.74310684204102 22.84175872802734 L 47.97241973876953 8.270418167114258 L 47.90351867675781 8.004154205322266 L 48.39359664916992 8.005241394042969 L 54.25798797607422 8.01823902130127 L 54.74642562866211 8.019322395324707 L 54.81867980957031 8.285112380981445 L 57.95844650268555 19.83441734313965 L 67.26917266845703 19.82603645324707 L 67.76564025878906 19.82558822631836 L 67.84609985351562 20.10280990600586 L 68.63267517089844 22.81319427490234 L 68.71402740478516 23.09352111816406 Z M 52.6766242980957 22.55882835388184 L 67.55351257324219 22.53476905822754 L 66.93256378173828 20.3813591003418 L 57.61008834838867 20.39112091064453 L 57.11040115356445 20.39164543151855 L 57.0352668762207 20.11333656311035 L 53.91304779052734 8.54914379119873 L 49.02238082885742 8.538989067077637 L 52.6766242980957 22.55882835388184 Z M 17.80468368530273 23.18340301513672 L 8.111839294433594 23.20051956176758 L 7.596301555633545 23.20142936706543 L 7.546005249023438 22.91651153564453 L 4.944218635559082 8.178056716918945 L 4.896692276000977 7.90882682800293 L 5.397927761077881 7.909937381744385 L 14.8225793838501 7.930827617645264 C 15.42120838165283 7.932155132293701 16.00497436523438 7.942837238311768 16.5729866027832 7.962807178497314 C 17.14087104797363 7.982770919799805 17.69306182861328 8.012018203735352 18.22866249084473 8.050481796264648 C 18.76419067382812 8.088939666748047 19.28318214416504 8.136615753173828 19.78473281860352 8.193441390991211 C 20.28626441955566 8.250264167785645 20.77040481567383 8.316243171691895 21.23625564575195 8.391315460205078 C 21.70842170715332 8.467406272888184 22.16524887084961 8.553375244140625 22.60604095458984 8.649025917053223 C 23.04690361022949 8.744690895080566 23.47176551818848 8.850049018859863 23.87994766235352 8.964912414550781 C 24.28822898864746 9.079802513122559 24.67985534667969 9.204211235046387 25.05413818359375 9.337952613830566 C 25.42853927612305 9.471735954284668 25.78562164306641 9.614867210388184 26.12468338012695 9.767165184020996 C 26.80241394042969 10.07158660888672 27.41372871398926 10.4148530960083 27.9579906463623 10.79632377624512 C 28.50290870666504 11.17825794219971 28.98081207275391 11.59863090515137 29.3909740447998 12.05683517456055 C 29.80178070068359 12.51576328277588 30.14478302001953 13.01281452178955 30.41917610168457 13.54741859436035 C 30.6940975189209 14.08306217193604 30.90024185180664 14.65659999847412 31.03672027587891 15.26749801635742 C 31.16787528991699 15.85457038879395 31.20807266235352 16.4151668548584 31.15742111206055 16.94831848144531 C 31.10666275024414 17.48259162902832 30.96468353271484 17.98923873901367 30.73162269592285 18.4672966003418 C 30.49810028076172 18.94629287719727 30.17316818237305 19.39652252197266 29.75700378417969 19.81701278686523 C 29.3400764465332 20.2382755279541 28.83163833618164 20.6296329498291 28.2319221496582 20.99012184143066 C 27.63249588012695 21.35042572021484 26.96399307250977 21.66702270507812 26.22790908813477 21.93943214416504 C 25.49077415466309 22.21222877502441 24.68605995178223 22.44063377380371 23.81532859802246 22.62419128417969 C 22.94358825683594 22.80796051025391 22.00592231750488 22.94673156738281 21.00395011901855 23.04007911682129 C 20.00110054016113 23.13350677490234 18.93411636352539 23.1814136505127 17.80468368530273 23.18340301513672 Z M 8.525634765625 22.63022804260254 L 17.69363212585449 22.61540222167969 C 18.75359535217285 22.61368751525879 19.75410270690918 22.5694637298584 20.69359016418457 22.48308563232422 C 21.63231086730957 22.39678001403809 22.50986671447754 22.26840782165527 23.32474708557129 22.09835243225098 C 24.13875389099121 21.92848014831543 24.8900146484375 21.71705627441406 25.57707595825195 21.46449279785156 C 26.26322746276855 21.21226119995117 26.88517951965332 20.9190616607666 27.4415397644043 20.58533477783203 C 27.99571418762207 20.25291442871094 28.46556282043457 19.89119338989258 28.85085296630859 19.50106430053711 C 29.23549652099609 19.11160087585449 29.53582000732422 18.69387245178223 29.75164985656738 18.2487850189209 C 29.96708679199219 17.80450820922852 30.09830284118652 17.3330249786377 30.14515686035156 16.83522796630859 C 30.19191932678223 16.33840179443359 30.15463829040527 15.81542587280273 30.03320121765137 15.26719284057617 C 29.90672874450684 14.69623279571533 29.71694183349609 14.16097259521484 29.46463966369629 13.66191864013672 C 29.21279525756836 13.16376686096191 28.89857292175293 12.7015209197998 28.52271270751953 12.27571868896484 C 28.14740180969238 11.85053825378418 27.71049308776855 11.46154594421387 27.21265029907227 11.1093111038208 C 26.71536636352539 10.75747203826904 26.15710830688477 10.44218349456787 25.5384693145752 10.16405391693115 C 24.91679382324219 9.884559631347656 24.22777557373047 9.639430046081543 23.47284317016602 9.428818702697754 C 22.71823692321777 9.218300819396973 21.89752006530762 9.04219913482666 21.01205062866211 8.900702476501465 C 20.12665939331055 8.759219169616699 19.17622756958008 8.652289390563965 18.16205787658691 8.580136299133301 C 17.14763069152832 8.507965087890625 16.06908226013184 8.470564842224121 14.92764377593994 8.468194961547852 L 5.995144367218018 8.449647903442383 L 8.525634765625 22.63022804260254 Z M 16.79351997375488 20.43386077880859 L 13.76034927368164 20.43703842163086 L 13.24902725219727 20.43757438659668 L 13.19609451293945 20.1560230255127 L 11.44258785247803 10.82911396026611 L 11.39153861999512 10.55757999420166 L 11.8936653137207 10.55834770202637 L 14.83513355255127 10.56284713745117 C 15.52964305877686 10.56391143798828 16.19297981262207 10.59142684936523 16.82428550720215 10.64520454406738 C 17.45551109313965 10.69897270202637 18.05487060546875 10.77900981903076 18.6214714050293 10.88514232635498 C 19.18813705444336 10.991286277771 19.72217559814453 11.12355899810791 20.22267913818359 11.28180503845215 C 20.72336387634277 11.44010829925537 21.19060707092285 11.62444114685059 21.62347793579102 11.83466911315918 C 22.05694389343262 12.04518413543701 22.44677352905273 12.2758150100708 22.79253959655762 12.52611827850342 C 23.13858032226562 12.77661514282227 23.44054985046387 13.04686641693115 23.6979923248291 13.33642578125 C 23.9556884765625 13.62627506256104 24.16881370544434 13.93552780151367 24.33687782287598 14.26376056671143 C 24.50514030456543 14.59238147735596 24.62826538085938 14.94008636474609 24.70573425292969 15.30645656585693 C 24.78743743896484 15.69288730621338 24.81536102294922 16.06099128723145 24.78961753845215 16.41016387939453 C 24.76383781433105 16.75981140136719 24.68424415588379 17.09044075012207 24.55097007751465 17.40144920349121 C 24.41752433776855 17.71285438537598 24.23027610778809 18.00455856323242 23.98937225341797 18.27594947814941 C 23.74818992614746 18.54766464233398 23.45324516296387 18.79899597167969 23.10471153259277 19.02934074401855 C 22.75422859191895 19.26097869873047 22.35878753662109 19.4643383026123 21.91929626464844 19.63916015625 C 21.47941017150879 19.81414031982422 20.99546813964844 19.96048927307129 20.4684009552002 20.07795143127441 C 19.94095611572266 20.19550132751465 19.37041473388672 20.28409767150879 18.75774765014648 20.34350204467773 C 18.14474105834961 20.4029369354248 17.48966979980469 20.43313217163086 16.79351997375488 20.43386077880859 Z M 14.16467571258545 19.87384223937988 L 16.68408203125 19.8715763092041 C 17.30683135986328 19.87101554870605 17.89194679260254 19.84472465515137 18.43855857849121 19.79289436340332 C 18.98490905761719 19.7410945892334 19.49270439147949 19.66378593444824 19.96110534667969 19.56118774414062 C 20.4292106628418 19.45865631103516 20.85789489746094 19.33087921142578 21.24633598327637 19.17808151245117 C 21.63446998596191 19.02539825439453 21.98236846923828 18.8477611541748 22.28922653198242 18.64538764953613 C 22.59737586975098 18.44216728210449 22.8580322265625 18.21930122375488 23.071044921875 17.97731781005859 C 23.28383255004883 17.73559379577637 23.44905662536621 17.47481727600098 23.56657028198242 17.19553375244141 C 23.68395233154297 16.91656875610352 23.75371932983398 16.61916160583496 23.7757511138916 16.30385589599609 C 23.79776000976562 15.98893928527832 23.77214431762695 15.6561918258667 23.69879913330078 15.30616092681885 C 23.62998008728027 14.97773551940918 23.52140426635742 14.66659545898438 23.3735179901123 14.37311935424805 C 23.22578811645508 14.07995700836182 23.03881454467773 13.80437183380127 22.81301498413086 13.54675006866455 C 22.58740997314453 13.28935623168945 22.3230152130127 13.04985046386719 22.02022933959961 12.82862377166748 C 21.71765518188477 12.60755443572998 21.37668800354004 12.40470027923584 20.99771118164062 12.22046756744385 C 20.61860847473145 12.03617382049561 20.20703506469727 11.87457752227783 19.76383781433105 11.73580169677734 C 19.32077789306641 11.59706592559814 18.84601402282715 11.48110866546631 18.34036445617676 11.38806247711182 C 17.83476638793945 11.2950267791748 17.29818534851074 11.22488021850586 16.73141479492188 11.17777252197266 C 16.16458320617676 11.13066101074219 15.5674352645874 11.10658740997314 14.94075202941895 11.10571384429932 L 12.49882411956787 11.10232543945312 L 14.16467571258545 19.87384223937988 Z M 46.03977203369141 18.60577201843262 L 45.53878021240234 18.60606002807617 L 35.34049606323242 18.61191558837891 L 34.83667373657227 18.61220359802246 L 34.77296829223633 18.33416175842285 L 34.25299072265625 16.06477546691895 L 34.18989181518555 15.789381980896 L 34.69113159179688 15.78946590423584 L 44.83731079101562 15.79115295410156 L 45.33575820922852 15.79123783111572 L 45.40444183349609 16.06582641601562 L 45.97042846679688 18.32855033874512 L 46.03977203369141 18.60577201843262 Z M 35.7158203125 18.05597686767578 L 44.9000358581543 18.05204200744629 L 44.47518157958984 16.34067726135254 L 35.31951141357422 16.34047889709473 L 35.7158203125 18.05597686767578 Z M 70.55390930175781 11.03394412994385 C 70.28215789794922 11.03355693817139 70.01808166503906 11.02175331115723 69.76214599609375 10.99861145019531 C 69.50620269775391 10.97547054290771 69.25840759277344 10.94099235534668 69.01921844482422 10.895263671875 C 68.78003692626953 10.84953594207764 68.54945373535156 10.79255962371826 68.32794189453125 10.72442436218262 C 68.1064453125 10.65629863739014 67.89403533935547 10.57701969146729 67.69111633300781 10.48668003082275 C 67.48540496826172 10.39509582519531 67.30014801025391 10.29799365997314 67.13552093505859 10.19557094573975 C 66.97096252441406 10.09318351745605 66.82704925537109 9.985487937927246 66.70399475097656 9.872689247131348 C 66.58099365234375 9.759937286376953 66.47883605957031 9.642090797424316 66.39775848388672 9.519359588623047 C 66.31670379638672 9.396681785583496 66.25669097900391 9.269129753112793 66.21792602539062 9.13691234588623 C 66.17801666259766 9.000776290893555 66.16263580322266 8.870522499084473 66.17163848876953 8.746337890625 C 66.18064117431641 8.622215270996094 66.21401977539062 8.504156112670898 66.27166748046875 8.39234733581543 C 66.32927703857422 8.28059196472168 66.4111328125 8.175078392028809 66.51709747314453 8.075995445251465 C 66.62303161621094 7.976959228515625 66.75306701660156 7.884344577789307 66.90708923339844 7.798342704772949 C 67.05725860595703 7.71449089050293 67.22299194335938 7.641082286834717 67.40392303466797 7.578177452087402 C 67.58477020263672 7.515294551849365 67.78082275390625 7.462906360626221 67.99170684814453 7.421077251434326 C 68.2025146484375 7.379259586334229 68.42816925048828 7.34799337387085 68.66828918457031 7.327345848083496 C 68.90834808349609 7.306700229644775 69.16289520263672 7.29666805267334 69.43156433105469 7.297317504882812 C 69.70338439941406 7.2979736328125 69.96685028076172 7.309272766113281 70.22156524658203 7.33113956451416 C 70.47626495361328 7.353003978729248 70.72223663330078 7.385436058044434 70.95906829833984 7.428362846374512 C 71.1959228515625 7.471292018890381 71.42366790771484 7.524719715118408 71.64192199707031 7.588575839996338 C 71.86018371582031 7.652442932128906 72.06897735595703 7.726747035980225 72.26786041259766 7.811421871185303 C 72.47145080566406 7.898097991943359 72.65523529052734 7.991245746612549 72.81899261474609 8.090679168701172 C 72.98280334472656 8.190142631530762 73.12660217285156 8.295902252197266 73.25016784667969 8.407771110534668 C 73.37376403808594 8.519681930541992 73.47712707519531 8.637716293334961 73.56002044677734 8.761685371398926 C 73.64296722412109 8.885710716247559 73.70541381835938 9.01568603515625 73.74715423583984 9.151426315307617 C 73.78933715820312 9.288582801818848 73.80735015869141 9.42005443572998 73.80126190185547 9.545638084411621 C 73.79518127441406 9.671284675598145 73.76498413085938 9.791033744812012 73.71075439453125 9.904679298400879 C 73.65648651123047 10.0183801651001 73.57817077636719 10.12596797943115 73.47584533691406 10.22723960876465 C 73.37348937988281 10.32855796813965 73.24712371826172 10.42355251312256 73.09685516357422 10.51201725006104 C 72.94927215576172 10.59889602661133 72.78512573242188 10.67504596710205 72.60481262207031 10.74038124084473 C 72.42440795898438 10.80573844909668 72.22782897949219 10.86026859283447 72.01543426513672 10.90388774871826 C 71.802978515625 10.94751644134521 71.57471466064453 10.980224609375 71.33102416992188 11.00192832946777 C 71.08727264404297 11.02363681793213 70.82810974121094 11.03433609008789 70.55390930175781 11.03394412994385 Z M 69.59022521972656 7.825578212738037 C 69.37914276123047 7.82509708404541 69.18150329589844 7.83231782913208 68.99678802490234 7.847348213195801 C 68.81201171875 7.862380981445312 68.64015197753906 7.885227680206299 68.48061370849609 7.916000843048096 C 68.321044921875 7.946778774261475 68.17378234863281 7.985487461090088 68.03830718994141 8.032238960266113 C 67.90277862548828 8.07900333404541 67.77902221679688 8.133817672729492 67.66645812988281 8.196795463562012 C 67.55771636962891 8.25764274597168 67.46640777587891 8.32252025604248 67.39242553710938 8.391706466674805 C 67.31840515136719 8.460912704467773 67.26171875 8.534431457519531 67.22222900390625 8.612537384033203 C 67.18271636962891 8.690669059753418 67.16043853759766 8.773395538330078 67.15519714355469 8.860992431640625 C 67.14997863769531 8.948620796203613 67.16181945800781 9.041125297546387 67.19063568115234 9.138786315917969 C 67.21868896484375 9.233881950378418 67.26116943359375 9.324793815612793 67.31835174560547 9.411796569824219 C 67.37554931640625 9.49882698059082 67.44749450683594 9.581944465637207 67.53446197509766 9.661418914794922 C 67.6214599609375 9.740914344787598 67.72349548339844 9.816764831542969 67.84088134765625 9.889246940612793 C 67.95831298828125 9.961743354797363 68.09107208251953 10.03086471557617 68.239501953125 10.09689044952393 C 68.39083099365234 10.1642017364502 68.54837799072266 10.22291851043701 68.71275329589844 10.27315330505371 C 68.87716674804688 10.32339191436768 69.04837799072266 10.36514186859131 69.22706604003906 10.39852046966553 C 69.40575408935547 10.4318962097168 69.59187316894531 10.45689678192139 69.78604888916016 10.47363376617432 C 69.98021697998047 10.4903736114502 70.18243408203125 10.4988489151001 70.39329528808594 10.49917984008789 C 70.60768127441406 10.49951553344727 70.80794525146484 10.49193572998047 70.99459838867188 10.47633075714111 C 71.18123626708984 10.46072959899902 71.35427093505859 10.43710517883301 71.51428985595703 10.40534973144531 C 71.67427062988281 10.37360000610352 71.82120513916016 10.33372783660889 71.95569610595703 10.28562068939209 C 72.09011077880859 10.23752689361572 72.21207427978516 10.18120765686035 72.32212829589844 10.11655712127686 C 72.42935943603516 10.05356693267822 72.51907348632812 9.986537933349609 72.5914306640625 9.915189743041992 C 72.66376495361328 9.843865394592285 72.71874237060547 9.76822566986084 72.75651550292969 9.687992095947266 C 72.79428100585938 9.607786178588867 72.81484222412109 9.522990226745605 72.81833648681641 9.43332576751709 C 72.82183074951172 9.343690872192383 72.80827331542969 9.249195098876953 72.77781677246094 9.149557113647461 C 72.74796295166016 9.051905632019043 72.70442199707031 8.959359169006348 72.64691925048828 8.871633529663086 C 72.58943176269531 8.783935546875 72.51795196533203 8.701050758361816 72.43222808837891 8.622699737548828 C 72.34651184082031 8.544367790222168 72.24653625488281 8.470563888549805 72.13198852539062 8.401003837585449 C 72.01746368408203 8.331459045410156 71.88836669921875 8.266154289245605 71.74439239501953 8.20481014251709 C 71.59574127197266 8.141474723815918 71.44024658203125 8.086227416992188 71.27723693847656 8.038952827453613 C 71.11425018310547 7.991683483123779 70.94375610351562 7.952381610870361 70.76512145996094 7.920933723449707 C 70.58648681640625 7.889487743377686 70.39970397949219 7.865892887115479 70.20409393310547 7.85003662109375 C 70.00850677490234 7.834181785583496 69.80409240722656 7.826065063476562 69.59022521972656 7.825578212738037 Z",
    stroke: "none",
    fill: "#140101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    transform: "translate(13 162)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 123,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 477,
    height: 120,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "D-LINK-2",
    "data-name": "D-LINK",
    transform: "translate(27 166)",
    fontSize: 20,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "D-LINK")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    transform: "translate(162 202)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 315,
    height: 58,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 312,
    height: 55,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hdmi-svgrepo-com",
    transform: "translate(23.066 148.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(148.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(180.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-2",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-2",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138",
    transform: "translate(212.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-3",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-3",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(249.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-4",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-4",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    transform: "translate(281.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-5",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-5",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(313.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-6",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-6",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142",
    transform: "translate(350.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-7",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-7",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143",
    transform: "translate(382.444 86.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-8",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-8",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 6.284)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(333 28.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-9",
    "data-name": "Path 295",
    d: "M89.8,179.2H60.4c-.369,0-.668.461-.668,1.029v12.35a1.36,1.36,0,0,0,.2.728l2.673,4.117a.582.582,0,0,0,.472.3H87.13a.582.582,0,0,0,.472-.3l2.673-4.117a1.36,1.36,0,0,0,.2-.728v-12.35C90.471,179.661,90.172,179.2,89.8,179.2Zm-.668,12.953-2.281,3.514h-23.5l-2.281-3.514V181.258H89.135Z",
    transform: "translate(21.71 -120.933)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-9",
    "data-name": "Rectangle 70",
    transform: "translate(83.934 64.551)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(148.444 62.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131-2",
    "data-name": "Group 131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-10",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-10",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137-2",
    "data-name": "Group 137",
    transform: "translate(32 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-11",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-11",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138-2",
    "data-name": "Group 138",
    transform: "translate(64 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-12",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-12",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(249.444 62.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131-3",
    "data-name": "Group 131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-13",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-13",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137-3",
    "data-name": "Group 137",
    transform: "translate(32 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-14",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-14",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138-3",
    "data-name": "Group 138",
    transform: "translate(64 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-15",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-15",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(350.444 62.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_131-4",
    "data-name": "Group 131",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-16",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-16",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137-4",
    "data-name": "Group 137",
    transform: "translate(32 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-17",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-17",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_138-4",
    "data-name": "Group 138",
    transform: "translate(64 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295-18",
    "data-name": "Path 295",
    d: "M89.8,197.725H60.4c-.369,0-.668-.461-.668-1.029v-12.35a1.36,1.36,0,0,1,.2-.728L62.6,179.5a.582.582,0,0,1,.472-.3H87.13a.582.582,0,0,1,.472.3l2.673,4.117a1.36,1.36,0,0,1,.2.728V196.7C90.471,197.264,90.172,197.725,89.8,197.725Zm-.668-12.953-2.281-3.514h-23.5l-2.281,3.514v10.894H89.135Z",
    transform: "translate(-59.734 -179.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_70-18",
    "data-name": "Rectangle 70",
    transform: "translate(2.489 8.241)",
    fill: "#fff",
    stroke: "#0a0101",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    y2: 57,
    transform: "translate(269.5 202.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y2: 57,
    transform: "translate(370.5 202.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M6416,1037.231h58.985l19.354,11.543,61.085,3.42,25.4,9.833H6416Z",
    transform: "translate(-6403 -777.718)",
    fill: "#787171",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-2",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-2",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-2",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-2",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-2",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-2",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-2",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-2",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-2",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149-2",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-3",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-3",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-3",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-3",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-3",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-3",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-3",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-3",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-3",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150-2",
    "data-name": "Group 150",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-4",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-4",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-4",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-4",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-4",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-4",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-4",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-4",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-4",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151-2",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149-3",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-5",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-5",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-5",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-5",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-5",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-5",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-5",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-5",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-5",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150-3",
    "data-name": "Group 150",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-6",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-6",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-6",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-6",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-6",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-6",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-6",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-6",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-6",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_152-2",
    "data-name": "Group 152",
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_149-4",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-7",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-7",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-7",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-7",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-7",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-7",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-7",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-7",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-7",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150-4",
    "data-name": "Group 150",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-8",
    "data-name": "Ellipse 60",
    transform: "translate(59 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-8",
    "data-name": "Ellipse 61",
    transform: "translate(66 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-8",
    "data-name": "Ellipse 62",
    transform: "translate(73 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_63-8",
    "data-name": "Ellipse 63",
    transform: "translate(80 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_64-8",
    "data-name": "Ellipse 64",
    transform: "translate(87 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_65-8",
    "data-name": "Ellipse 65",
    transform: "translate(94 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_66-8",
    "data-name": "Ellipse 66",
    transform: "translate(101 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_67-8",
    "data-name": "Ellipse 67",
    transform: "translate(108 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_68-8",
    "data-name": "Ellipse 68",
    transform: "translate(115 195)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    transform: "translate(182 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    transform: "translate(214 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    transform: "translate(246 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    transform: "translate(283 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    transform: "translate(315 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    transform: "translate(348 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    transform: "translate(380 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    transform: "translate(416 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    transform: "translate(448 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(0 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_69-2",
    "data-name": "Ellipse 69",
    transform: "translate(182 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_70-2",
    "data-name": "Ellipse 70",
    transform: "translate(214 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_71-2",
    "data-name": "Ellipse 71",
    transform: "translate(246 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_72-2",
    "data-name": "Ellipse 72",
    transform: "translate(283 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_73-2",
    "data-name": "Ellipse 73",
    transform: "translate(315 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_74-2",
    "data-name": "Ellipse 74",
    transform: "translate(348 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_75-2",
    "data-name": "Ellipse 75",
    transform: "translate(380 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_76-2",
    "data-name": "Ellipse 76",
    transform: "translate(416 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_77-2",
    "data-name": "Ellipse 77",
    transform: "translate(448 193)",
    stroke: "#000",
    strokeWidth: 1,
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 3,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdc);
export default __webpack_public_path__ + "static/media/PDC.4cc656015c4d39a03febc8b855cf1843.svg";
export { ForwardRef as ReactComponent };